@import (reference) '../../../../../constants/spacing.module.less';

.recommend-package-button {
  height: 32px;
  color: var(--default--text-color--17);
}

.sparkle-icon {
  width: 14px;
  height: 14px;
  margin-right: @space-8;
}
